// extracted by mini-css-extract-plugin
export default {"overlay":"PageLoader_overlay__X05h-","loaderBox":"PageLoader_loaderBox__PjOGe","spinner":"PageLoader_spinner__4CHvi","spin":"PageLoader_spin__XX6-H","text":"PageLoader_text__Hu6WF"};